import { api } from "@/api/client";
import { PasswordForm } from "./ResetPassword";

/** Migrated accounts: same form as a reset, with the "your account moved" framing. */
export default function SetPassword() {
  return (
    <PasswordForm
      title="Welcome to the new EventPass"
      subtitle="Your account came with us. Set a password to keep using it."
      buttonText="Set password"
      submitToken={api.auth.setPassword}
    />
  );
}
